export async function exportAnswer(element: HTMLElement, title: string) {
  const {
    Document,
    Packer,
    Paragraph,
    TextRun,
    ExternalHyperlink,
    HeadingLevel,
    Table,
    TableRow,
    TableCell,
  } = await import("docx");
  const { saveAs } = await import("file-saver");
  function runs(node: Node, bold = false, italics = false): any[] {
    if (node.nodeType === Node.TEXT_NODE)
      return (node.textContent || "")
        .split("\n")
        .flatMap((text, i) => [
          ...(i ? [new TextRun({ break: 1 })] : []),
          new TextRun({ text, bold, italics }),
        ]);
    if (!(node instanceof HTMLElement)) return [];
    if (node.tagName === "BR") return [new TextRun({ break: 1 })];
    const children = Array.from(node.childNodes).flatMap(n =>
      runs(
        n,
        bold || ["STRONG", "B"].includes(node.tagName),
        italics || ["EM", "I"].includes(node.tagName)
      )
    );
    if (
      node.tagName === "A" &&
      /^(https?:|mailto:)/i.test(node.getAttribute("href") || "")
    )
      return [
        new ExternalHyperlink({ link: node.getAttribute("href")!, children }),
      ];
    return children;
  }
  function blocks(parent: HTMLElement): any[] {
    return Array.from(parent.children).flatMap((node): any[] => {
      const el = node as HTMLElement,
        tag = el.tagName;
      if (tag === "BUTTON") return [];
      if (tag === "TABLE")
        return [
          new Table({
            rows: Array.from(el.querySelectorAll("tr")).map(
              row =>
                new TableRow({
                  children: Array.from(row.children).map(
                    cell =>
                      new TableCell({
                        children: [new Paragraph({ children: runs(cell) })],
                      })
                  ),
                })
            ),
          }),
        ];
      if (tag === "UL" || tag === "OL")
        return Array.from(el.children).map(
          (li, i) =>
            new Paragraph({
              children: [
                ...(tag === "OL" ? [new TextRun(`${i + 1}. `)] : []),
                ...runs(li),
              ],
              ...(tag === "UL" ? { bullet: { level: 0 } } : {}),
            })
        );
      if (["DIV", "SECTION"].includes(tag)) return blocks(el);
      return [
        new Paragraph({
          children: runs(el),
          spacing: { after: 180 },
          ...(/^H[1-6]$/.test(tag)
            ? {
                heading:
                  tag === "H1"
                    ? HeadingLevel.HEADING_1
                    : HeadingLevel.HEADING_2,
              }
            : {}),
        }),
      ];
    });
  }
  const doc = new Document({
    sections: [
      {
        children: [
          new Paragraph({ text: title, heading: HeadingLevel.TITLE }),
          ...blocks(element),
        ],
      },
    ],
  });
  saveAs(
    await Packer.toBlob(doc),
    `${title.replace(/[^\w -]/g, "").slice(0, 100) || "Reviewed answer"}.docx`
  );
}
